import { computed } from 'vue';

import { BRAND, USER } from '@/models/auth/permissions.enum';
import { useAuthStore } from '@/stores/auth';

export function useChannelPermissions() {
  const authStore = useAuthStore();

  // TikTok
  const canUserAccessTikTok = computed(() =>
    authStore.guard(USER.TIKTOK.CAN_ACCESS_TIKTOK_INSIGHTS),
  );

  const canBrandAccessTikTok = computed(() =>
    authStore.guard(BRAND.TIKTOK.CAN_ACCESS_TIKTOK_INSIGHTS),
  );

  const canAccessTikTok = computed(() => canUserAccessTikTok.value && canBrandAccessTikTok.value);

  // Facebook
  const canUserAccessFacebook = computed(() =>
    authStore.guard(USER.FACEBOOK.CAN_ACCESS_FB_INSIGHTS),
  );

  const canBrandAccessFacebook = computed(() =>
    authStore.guard(BRAND.FACEBOOK.CAN_ACCESS_FB_INSIGHTS),
  );

  const canAccessFacebook = computed(
    () => canUserAccessFacebook.value && canBrandAccessFacebook.value,
  );

  // X
  const canUserAccessX = computed(() => authStore.guard(USER.TWITTER.CAN_ACCESS_TWITTER_INSIGHTS));

  const canBrandAccessX = computed(() =>
    authStore.guard(BRAND.TWITTER.CAN_ACCESS_TWITTER_INSIGHTS),
  );

  const canAccessX = computed(() => canUserAccessX.value && canBrandAccessX.value);

  // YouTube
  const canUserAccessYouTube = computed(() =>
    authStore.guard(USER.YOUTUBE.CAN_ACCESS_YOUTUBE_INSIGHTS),
  );

  const canBrandAccessYouTube = computed(() =>
    authStore.guard(BRAND.YOUTUBE.CAN_ACCESS_YOUTUBE_INSIGHTS),
  );

  const canAccessYouTube = computed(
    () => canUserAccessYouTube.value && canBrandAccessYouTube.value,
  );

  // Pinterest
  const canUserAccessPinterest = computed(() => authStore.guard(USER.PINTEREST.CAN_ACCESS_PINT));

  const canBrandAccessPinterest = computed(() => authStore.guard(BRAND.PINTEREST.CAN_ACCESS_PINT));

  const canAccessPinterest = computed(
    () => canUserAccessPinterest.value && canBrandAccessPinterest.value,
  );

  // Instagram
  const canUserAccessInstagram = computed(() =>
    authStore.guard(USER.INSTAGRAM.CAN_ACCESS_INSTAGRAM),
  );

  const canBrandAccessInstagram = computed(() =>
    authStore.guard(BRAND.INSTAGRAM.CAN_ACCESS_INSTAGRAM),
  );

  const canAccessInstagram = computed(
    () => canUserAccessInstagram.value && canBrandAccessInstagram.value,
  );

  // LinkedIn
  const canUserAccessLinkedIn = computed(() =>
    authStore.guard(USER.LINKEDIN.CAN_ACCESS_LINKEDIN_INSIGHTS),
  );

  const canBrandAccessLinkedIn = computed(() =>
    authStore.guard(BRAND.LINKEDIN.CAN_ACCESS_LINKEDIN_INSIGHTS),
  );

  const canAccessLinkedIn = computed(
    () => canUserAccessLinkedIn.value && canBrandAccessLinkedIn.value,
  );

  // Threads
  const canUserAccessThreads = computed(() =>
    authStore.guard(USER.THREADS.CAN_ACCESS_THREADS_INSIGHTS),
  );

  const canBrandAccessThreads = computed(() =>
    authStore.guard(BRAND.THREADS.CAN_ACCESS_THREADS_INSIGHTS),
  );

  const canAccessThreads = computed(
    () => canUserAccessThreads.value && canBrandAccessThreads.value,
  );

  return {
    canUserAccessTikTok,
    canBrandAccessTikTok,
    canAccessTikTok,
    canUserAccessFacebook,
    canBrandAccessFacebook,
    canAccessFacebook,
    canUserAccessX,
    canBrandAccessX,
    canAccessX,
    canUserAccessYouTube,
    canBrandAccessYouTube,
    canAccessYouTube,
    canUserAccessPinterest,
    canBrandAccessPinterest,
    canAccessPinterest,
    canUserAccessInstagram,
    canBrandAccessInstagram,
    canAccessInstagram,
    canUserAccessLinkedIn,
    canBrandAccessLinkedIn,
    canAccessLinkedIn,
    canUserAccessThreads,
    canBrandAccessThreads,
    canAccessThreads,
  };
}
